import React from 'react';
import ThemeMenu from './ThemeMenu';
import { REACTIONS_SVG_URLS, CUSTOM_REACTION_PREFIX, DEFAULT_TITLE } from './consts';
import { Theme } from './types';

interface Props {
  spotId: string;
  themeName: string;
  theme: Theme;
  isDefault: boolean;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onToggleActiveStatus: () => void;
}

const ThemePreview: React.FC<Props> = ({
  spotId,
  theme,
  isDefault = false,
  onEditClick,
  onDeleteClick,
  onToggleActiveStatus
}) => {
  const titleToDisplay = theme.title === null ? DEFAULT_TITLE : theme.title;
  return (
    <div className={`theme-preview-container ${theme.enabled ? 'enabled' : ''}`}>
      <div className="theme-preview-fields">
        <div onClick={() => onEditClick()} className="theme-name">
          {theme.name}
        </div>
        <div className="theme-title-keywords">
          {titleToDisplay}
          {theme.keywords && ` · Keywords: ${theme.keywords}`}
        </div>
        <ul className="theme-icons">
          {(theme.reactions || [])
            .filter(reaction => reaction.is_active)
            .map(reaction => {
              const imageUrl = REACTIONS_SVG_URLS[reaction.id];

              let customImage = reaction.custom_image_id;
              if (customImage) {
                customImage = `${CUSTOM_REACTION_PREFIX}/${spotId}/${customImage}`;
              }

              return (
                imageUrl && (
                  <img
                    key={reaction.id}
                    className="theme-icon"
                    src={customImage || imageUrl}
                    alt={reaction.id}
                  />
                )
              );
            })}
        </ul>
      </div>

      <ThemeMenu
        isEnabled={theme.enabled}
        isDefault={isDefault}
        onEditClick={onEditClick}
        onDeleteClick={onDeleteClick}
        onToggleActiveStatus={onToggleActiveStatus}
      />
    </div>
  );
};

export default ThemePreview;
